// =============================================================================
//  Copyright   : 2018 semantics GmbH
//  Date        : $Date: 2024-07-11 22:06:38 +0200 (Thu, 11 Jul 2024) $
//  Author      : Dirk Rothe
//  Worker      : $Author: d.rothe $
//  Revision    : $Rev: 144561 $
//  Purpose     : call wiki apis
// =============================================================================
// ---Third-party imports
import {put, takeEvery} from 'redux-saga/effects'

// ---Framework imports
import {Actions} from 'uix/registries'
import Api from 'uix/api'
import {isNil} from 'ldash'
import log from 'uix/logging'
import {saveWikiText} from './actions'

// ---Globals

function* _saveWikiText({payload}) {
  let {text, identifier, otid, partName, dname, mimetype} = payload
  let params = otid ? {text, id: otid} : {text, ident: identifier}
  if (mimetype) {
    params = {...params, mimetype}
  }
  let {data, error} = yield Api.post(`/${dname}/api/saveWikiText`, params, {}, {silent: true})
  if (error) {
    yield put(Actions.errorNotification({error, header: 'Wiki Save Error'}))
  } else {
    yield put(Actions.successNotification({message: 'Wiki saved.'}))
    yield put(Actions.reloadPartFilters(partName))
  }
}

export const sagas = {
  saveWikiText: takeEvery(saveWikiText, _saveWikiText),
}
